import React from 'react'

import RefereeJudgeForm from '../Components/RefereeJudgeForm/RefereeJudgeForm'

const JudgeformPage = () => {
  return (
    <div>

      <RefereeJudgeForm />

    </div>
  )
}

export default JudgeformPage
